import api from '@/api'
import { SET_CLIENT_SLIDESHOW_LIST } from './mutation-types'
const state = {
  clientSlideshowList: [],
}
const mutations = {
  [SET_CLIENT_SLIDESHOW_LIST](state, payload) {
    state.clientSlideshowList = payload
  },
}
const actions = {
  async getSlideshowList({ state, commit }, payload) {
    let params = {
      picCarouselName: payload.picCarouselName,
      startTime: payload.startTime,
      endTime: payload.endTime,
    }
    try {
      const { data } = await api.deployApi.getSlideshowList(params)
      commit(SET_CLIENT_SLIDESHOW_LIST, data)
    } catch (error) {
      commit(SET_CLIENT_SLIDESHOW_LIST, [])
    }
  },
  refreshSlideshowList({ dispatch }) {
    dispatch('getSlideshowList', {})
  },
  // 新增
  async addSlideshow({ dispatch }, payload) {
    const result = await api.deployApi.addSlideshow(payload)
    dispatch('refreshSlideshowList')
    return result
  },
  // 编辑
  async editSlideshow({ dispatch }, payload) {
    const result = await api.deployApi.editSlideshow(payload)
    dispatch('refreshSlideshowList')
    return result
  },
  // 删除
  async deleteSlideshow({ dispatch }, payload) {
    const result = await api.deployApi.deleteSlideshow(payload)
    dispatch('refreshSlideshowList')
    return result
  },
  async exportSlideshow(_, payload) {
    const result = await api.deployApi.exportSlideshow(payload)
    return result
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
